import { useMutation, useQueryClient } from '@tanstack/react-query'
import { useServer } from 'app/server/context'
import keys from './shared/keys'

export function useRemoveUserPhoto() {
  const { server } = useServer()
  const client = useQueryClient()

  return useMutation({
    mutationKey: keys.account(),
    mutationFn: () => server.delete('/v2/users/me/profile/photo', 'user'),
    onSuccess: async () => {
      await client.invalidateQueries({ queryKey: keys.account() })
    },
  })
}
